import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { Product } from 'src/app/shared/product.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Observable } from 'rxjs';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ChangeImageComponent } from 'src/app/shared/change-image/change-image.component';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';
import { DistributorManufacturer } from 'src/app/super-admin/distributor-manufacturer.model';

@Component({
    selector: 'app-add-product',
    templateUrl: './add-product.component.html',
    styleUrls: ['./add-product.component.scss'],
    standalone: false
})
export class AddProductComponent implements OnInit {
  product: Product;
  addProductForm: FormGroup;
  addProductFromManufacturerForm: FormGroup;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  departmentCtrl = new FormControl();
  filteredDepartments: Observable<string[]>;
  departments: any[];
  allDepartments: any[];
  manufacturersList = new Array<DistributorManufacturer>();

  @ViewChild('departmentInput') departmentInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  departmentsList: any[];
  invalidDepartments: boolean;
  invalidImages = false;
  imagesList: Array<string>;
  fileList: Array<any>;
  selected = 'newProduct';
  userID: any;
  user: User;
  productSelected = 'newProduct';
  productCtrl = new FormControl();
  filteredProducts: Observable<string[]>;
  products: any[];
  allProducts: any[];

  @ViewChild('productInput') productInput: ElementRef<HTMLInputElement>;
  @ViewChild('autoProduct') matAutocompleteProduct: MatAutocomplete;
  productsList: any[];
  isLoading: boolean;

  constructor(public dialogRef: MatDialogRef<AddProductComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.invalidDepartments  = false;
                this.isLoading = false;
                this.user = this.authService.getUserData();
                this.getManufacturer();
                this.userID = this.user.id;
                this.departments = new Array<string>();
                this.allDepartments = new Array<string>();
                this.products = new Array<string>();
                this.allProducts = new Array<string>();
                this.imagesList = new Array<string>();
                this.fileList = new Array();
                this.product = this.data.product;
                this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
                  startWith(null),
                  map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
                this.filteredProducts = this.productCtrl.valueChanges.pipe(
                  startWith(null),
                  map((product: string | null) => product ? this._filterProduct(product) : this.allProducts.slice()));
              }

  ngOnInit(): void {
    this.addProductForm = new FormGroup({
      name: new FormControl(this.product ? this.product.name : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      description: new FormControl(this.product ? this.product.description : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      purpose: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
    this.addProductFromManufacturerForm = new FormGroup({
      manufacturer: new FormControl(null, [Validators.required]),
      productName: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
    this.getAllDepartments();
  }

  getAllDepartments() {
    this.isLoading = true;
    this.dataService.get('department/RetrieveDepartmentsByName?searchKeyword=', true).then((data) => {
      if (data.statusCode === 200) {
        this.departmentsList = [];
        this.allDepartments = [];
        this.departmentsList = data.data.records;
        this.departmentsList.forEach((productData) => {
          this.allDepartments.push(productData);
        });
        this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allDepartments.slice()));
      }
      this.isLoading = false;
      });
  }

  closeDialog() {
    if (this.selected === 'newProduct') {
      if (this.addProductForm.dirty) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Warning',
            type: 'Warn',
            message: 'You will miss your information once you close',
            buttonText: 'cancel',
            numberOfButtons: 2,
            seconButtonText: 'Ok'
          }
        });
        dialogRef.afterClosed().subscribe((status) => {
          if (status === 'Ok') {
            this.dialog.closeAll();
          }
        });
      } else {
        this.dialog.closeAll();
      }
    } else {
      if (this.addProductFromManufacturerForm.dirty) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Warning',
            type: 'Warn',
            message: 'You will miss your information once you close',
            buttonText: 'cancel',
            numberOfButtons: 2,
            seconButtonText: 'Ok'
          }
        });
        dialogRef.afterClosed().subscribe((status) => {
          if (status === 'Ok') {
            this.dialog.closeAll();
          }
        });
      } else {
        this.dialog.closeAll();
      }
    }
  }

  private _filter(value: any): any[] {
    return this.allDepartments.filter(department => department.name.toLowerCase().includes(value));
  }

  filterChange(value: any) {
    this.selected = value;
  }

  productFilterChange(value: any) {
    this.productSelected = value;
  }

  manufacturerFilterChange() {
    this.products = [];
    this.getAllProducts();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.departments.includes(value.trim())) {
        this.departments.push({
          id: Math.random(),
          name: value.trim()
        });

        this.invalidDepartments = false;
      }
    }

    if (input) {
      input.value = '';
    }

    this.departmentCtrl.setValue(null);
  }

  remove(department: any, index: any): void {
    if (index >= 0) {
      this.departments.splice(index, 1);
      if (this.departments.length > 0) {
        this.invalidDepartments = false;
      } else {
        this.invalidDepartments = true;
      }
    }
  }

  selectedDepartment(event: MatAutocompleteSelectedEvent): void {
    let departmentExist = false;
    for (let index = 0; index < this.departments.length; index++) {
      const element = this.departments[index];
      if (element.id === event.option.value.id) {
        departmentExist = true;
      }
    }
    if (!departmentExist) {
      this.departments.push(event.option.value);
    }
    this.departmentInput.nativeElement.value = '';
    this.departmentCtrl.setValue(null);

    if (this.departments.length > 0) {
      this.invalidDepartments = false;
    } else {
      this.invalidDepartments = true;
    }
  }

  searchDepartment(event: any) {
    if (this.departmentInput.nativeElement.value === "") {
      this.departmentsList = [];
      this.allDepartments = [];
      this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
        startWith(null),
        map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
    } else {
    this.isLoading = true;
    this.dataService.get('department/RetrieveDepartmentsByName?searchKeyword=' +
    this.departmentInput.nativeElement.value, true).then((data) => {
        if (data.statusCode === 200) {
          this.departmentsList = [];
          this.allDepartments = [];
          this.departmentsList = data.data.records;
          this.departmentsList.forEach((departmentData) => {
            this.allDepartments.push(departmentData);
          });
        }
        this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
          startWith(null),
          map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
        this.isLoading = false;
      });
    }
  }

  addProduct(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.products.includes(value.trim())) {
        this.products.push({
          id: Math.random(),
          name: value.trim()
        });
      }
    }

    if (input) {
      input.value = '';
    }

    this.productCtrl.setValue(null);
  }

  removeProduct(product: any, index: any): void {
    if (index >= 0) {
      this.products.splice(index, 1);
    }
  }

  selectedProduct(event: MatAutocompleteSelectedEvent): void {
    let productExist = false;
    for (let index = 0; index < this.products.length; index++) {
      const element = this.products[index];
      if (element.id === event.option.value.id) {
        productExist = true;
      }
    }
    if (!productExist) {
      this.products.push(event.option.value);
    }
    this.productInput.nativeElement.value = '';
    this.productCtrl.setValue(null);
   
  }

  private _filterProduct(value: any): any[] {
    return this.allProducts.filter(product => product.name.toLowerCase().includes(value));
  }

  searchProduct(event: any) {
    this.isLoading = true;
    this.dataService.get('product/RetrieveProductsByName?searchKeyword='
    + this.productInput.nativeElement.value + '&manufacturerId='
    + this.addProductFromManufacturerForm.get('manufacturer')?.value, true).then((data) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        this.allProducts = [];
        this.productsList = data.data.records;
        this.productsList.forEach((productData) => {
          this.allProducts.push(productData);
        });
        this.filteredProducts = this.productCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
      }
      this.isLoading = false;
      });
  }

  getAllProducts() {
    this.isLoading = true;
    this.dataService.get('product/RetrieveProductsByName?searchKeyword='
    + '&manufacturerId='
    + this.addProductFromManufacturerForm.get('manufacturer')?.value, true).then((data) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        this.allProducts = [];
        this.productsList = data.data.records;
        this.productsList.forEach((productData) => {
          this.allProducts.push(productData);
        });
        this.filteredProducts = this.productCtrl.valueChanges.pipe(
          startWith(null),
          map((product: string | null) => product ? this._filter(product) : this.allProducts.slice()));
      }
      this.isLoading = false;
      });
  }

  addProductImage() {
    this.dialog.open(ChangeImageComponent, {
      width: '610px',
      data: { dialogParent: this, title: 'Add New Image', resizeImage: true }
    }).afterClosed().subscribe(result => {
      if (result !== undefined && result.croppedImage64 !== undefined) {
        const imgSrc = result.croppedImage64;
        this.imagesList.push(imgSrc);
        this.fileList.push(result.ImageData);
        this.invalidImages = false;
      }
    });
  }

  deleteProductImage(index: number) {
    if (index > -1) {
      this.imagesList.splice(index, 1);
      this.fileList.splice(index, 1);
      if (this.imagesList.length === 0) {
        this.invalidImages = true;
      } else {
        this.invalidImages = false;
      }
    }
  }

  sendEmail() {
    if (this.products.length === 0 && this.productSelected === 'newProduct') {
      return;
    }

    const productsIds: number[] = [];
    for (let index = 0; index < this.products.length; index++) {
      const element = this.products[index];
      productsIds.push(element.id);
    }
    if (this.productSelected === 'newProduct') {
      this.addProductFromManufacturerForm.get('productName')?.setValue('empty');
    }

    if (this.addProductFromManufacturerForm.valid) {
      let payload = {};
      if (this.productSelected !== 'newProduct') {
        payload = {
          ProductName: this.addProductFromManufacturerForm.get('productName')?.value,
          ManufacturerId: parseInt(this.addProductFromManufacturerForm.get('manufacturer')?.value, 10),
          IsNewProduct: true
        };
      } else {
        payload = {
          ProductsIds: productsIds,
          ManufacturerId: parseInt(this.addProductFromManufacturerForm.get('manufacturer')?.value, 10),
          IsNewProduct: false
        };
      }

      this.dataService.post('ProductAccessRequest/ApplyForManufacturerSupport', payload).then((data) => {
        if (data.statusCode === 200) {
          this.dialogRef.close();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Product added successfully',
              buttonText: 'Ok'
            }
          });
        } else if (data.statusCode === 623) {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Warning',
              type: 'Warn',
              message: 'Request already sent!',
              buttonText: 'Ok',
              closeDialogRef: true
            }
          });
        }  else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });


    } else {
      this.addProductForm.markAllAsTouched();
    }
  }

  onSubmit() {
    if (this.departments.length > 0) {
      if (this.imagesList.length === 0) {
        this.invalidImages = true;
        this.addProductForm.markAllAsTouched();
        return;
      }
    } else {
      this.invalidDepartments = true;
      if (this.imagesList.length === 0) {
        this.invalidImages = true;
      }
      this.addProductForm.markAllAsTouched();
      return;
    }

    const departmentsIds: number[] = [];
    for (let index = 0; index < this.departments.length; index++) {
      const element = this.departments[index];
      departmentsIds.push(element.id);
    }

    if (this.addProductForm.valid && this.imagesList.length > 0) {
      this.utils.showProgressDialog();
      const payload = {
        name: this.addProductForm.get('name')?.value,
        description: this.addProductForm.get('description')?.value,
        purpose: this.addProductForm.get('purpose')?.value,
        departments: departmentsIds,
        picture: this.imagesList[0]
      };
      this.dataService.post('product/CreateProduct', payload, true).then((data) => {
        if (data.statusCode === 200) {
              const imagePayload = {
                productId: data.data.id,
                picturePaths: this.fileList.map((file: string) =>
                  file.replace(/^data:image\/[a-zA-Z]+;base64,/, '')
                )
              };
              this.dataService.put('product/UpdateProductPictures', imagePayload, true).then((mediaData) => {
                if (mediaData.statusCode === 200) {
                  payload.departments = this.departments;
                  payload['id'] = data.data.id;
                  this.dialogRef.close(payload);
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Success',
                      type: 'Success',
                      message: 'Product added successfully',
                      buttonText: 'Ok'
                    }
                  });
                } else {
                  const dialogRef = this.dialog.open(AlertDialogComponent, {
                    disableClose: true,
                    width: '400px',
                    data: {
                      title: 'Error',
                      type: 'Error',
                      message: 'Something went wrong, Please try again!',
                      buttonText: 'Ok'
                    }
                  });
                }
              });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
      this.utils.closeProgressDialog();
    } else {
      this.addProductForm.markAllAsTouched();
    }
  }

  getManufacturer() {
    this.dataService.get('manufacturer/RetrieveManufacturers').then((data) => {
      if (data.statusCode === 200) {
        this.manufacturersList = [];
        const manufacturersData = data.data.records;
        manufacturersData.forEach((manufacturerData) => {
          const manufacturerInstance = new DistributorManufacturer(manufacturerData);
          this.manufacturersList.push(manufacturerInstance);
        });
      }
    });
  }

}
